export const environment = {
  production: true,
  electron: false,
  branded: false
};
